import { Component, Inject, Injector, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { ApiViewerService } from "../../viewer-components/services/internal-services/api-viewer.service";
import { WmtsLayerComponent } from "./wmts-layer.component";
import { PhoenixWmtsLayerResultsDialogComponent } from "../wmts-layer-results-dialog/phoenix-wmts-layer-results-dialog.component";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  selector: "phoenix-wmts-component",
  templateUrl: "./wmts-layer.component.html",
  styleUrls: ["./wmts-layer.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixWmtsLayerComponent extends WmtsLayerComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    matDialog: MatDialog,

    public injector: Injector,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, matDialog, viewerService);
  }

  loadLayers() {
    const dialog = this.matDialog.open(PhoenixWmtsLayerResultsDialogComponent, {
      data: {
        viewerService: this.viewerService,
        url: this.url,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        layers: this.layers,
        tilesMatrixSet: this.tilesMatrixSet,
        matrixConfiguration: this.matrixConfiguration,
        isAuthRequired: this.isAuthRequired,
      },
      panelClass: "medium-panel-dialog",
      autoFocus: false,
      injector: this.injector,
    });
    dialog.afterClosed().subscribe(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "";
    });
  }
}
